import request from '@/utils/request.js';

// 获取用户未读消息数
export const getUserUnreadNumber = () => request({ url: '/v1/message/no_read_num', method: 'get' });

// 用户消息列表接口
export const getUserMessage = params => request({ url: '/v1/message/list', method: 'get', params });

// 用户当前绑定账号信息
export const getUserBindInfo = () => request({ url: '/v1/game_account/get_bind_info', method: 'get' });